import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=79a3797a"
import script from "./GoodsDetail.vue?vue&type=script&lang=js"
export * from "./GoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=79a3797a&prod&lang=css"
import style1 from "./GoodsDetail.vue?vue&type=style&index=1&id=79a3797a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports